module.exports = __webpack_public_path__ + "media/images/slider005-3085517b8369fa1ee1de21116baee481.jpg";